import { useEffect, useState } from "react";
import { X } from "lucide-react";

const COMPANIES = {
  misas: {
    label: "Misaş",
    title: "Mis-aş Gıda İnş. San. Ve Tic. A.Ş",
    logo: "https://customer-assets-0z36b82j.emergentagent.net/job_partner-registry-2/artifacts/4mwtidfk_misas.png",
  },
  mis_holding: {
    label: "Mis Holding",
    title: "Mis Holding A.Ş.",
    logo: "https://customer-assets-0z36b82j.emergentagent.net/job_partner-registry-2/artifacts/4d24m9nu_misholding.webp",
  },
  koop: {
    label: "Mis Koop.",
    title: "S.S. Mis Tüketim Kooperatifi",
    logo: "https://customer-assets-0z36b82j.emergentagent.net/job_partner-registry-2/artifacts/azkn7y74_miskoop.png",
  },
};

const KEY = "misland_intro_seen_v1";

export default function IntroSplash({ member }) {
  const myKeys = ["misas", "mis_holding", "koop"].filter(k => Number(member?.[`${k}_hisse`] || 0) > 0);
  const [visible, setVisible] = useState(() => {
    // Only show once per member per browser
    try {
      const seen = JSON.parse(localStorage.getItem(KEY) || "{}");
      return !seen[member?.id] && myKeys.length > 0;
    } catch { return true; }
  });
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(() => close(), 5200);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [visible]);

  const close = () => {
    setClosing(true);
    setTimeout(() => {
      setVisible(false);
      try {
        const seen = JSON.parse(localStorage.getItem(KEY) || "{}");
        seen[member.id] = new Date().toISOString();
        localStorage.setItem(KEY, JSON.stringify(seen));
      } catch { /* ignore */ }
    }, 450);
  };

  if (!visible) return null;

  const single = myKeys.length === 1;
  const first = member.ad_soyad ? member.ad_soyad.split(" ")[0] : "";

  return (
    <div
      data-testid="intro-splash"
      onClick={close}
      className={`fixed inset-0 z-[100] flex items-center justify-center cursor-pointer ${closing ? "intro-fade-out" : "intro-fade-in"}`}
      style={{
        background: "radial-gradient(ellipse at center, #0F172A 0%, #020617 100%)",
      }}>
      {/* Subtle grain */}
      <div className="absolute inset-0 opacity-[0.08]" style={{
        backgroundImage: "radial-gradient(#ffffff 0.5px, transparent 0.5px)",
        backgroundSize: "3px 3px",
      }} />

      <button
        data-testid="intro-close"
        onClick={(e) => { e.stopPropagation(); close(); }}
        className="absolute top-6 right-6 z-[120] text-white/70 hover:text-white p-2 rounded-full border border-white/20 hover:bg-white/10">
        <X size={16}/>
      </button>

      <div className="relative flex flex-col items-center gap-8 px-6 max-w-4xl w-full">
        <div className="text-center intro-text-in" style={{ animationDelay: "0.15s" }}>
          <div className="text-[11px] font-bold uppercase tracking-[0.3em] text-white/50">Hoş geldiniz</div>
          <div className="mt-2 text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
            {first}
          </div>
        </div>

        <div className={`grid gap-6 w-full ${single ? "grid-cols-1" : myKeys.length === 2 ? "grid-cols-1 sm:grid-cols-2" : "grid-cols-1 sm:grid-cols-3"}`}>
          {myKeys.map((k, i) => {
            const c = COMPANIES[k];
            return (
              <div key={k} data-testid={`intro-co-${k}`}
                   className="intro-logo-in flex flex-col items-center text-center bg-white/[0.06] backdrop-blur-sm border border-white/10 rounded-2xl px-8 py-8"
                   style={{ animationDelay: `${0.35 + i * 0.25}s` }}>
                <div className={`${single ? "h-32" : "h-24"} w-full flex items-center justify-center bg-white rounded-xl px-6`}>
                  <img src={c.logo} alt={c.title}
                       className="max-h-full max-w-full object-contain" />
                </div>
                <div className={`mt-5 font-extrabold text-white tracking-tight ${single ? "text-2xl sm:text-3xl" : "text-lg"}`}>
                  {c.title}
                </div>
                <div className="mt-2 text-[11px] font-bold uppercase tracking-[0.2em] text-white/60">Ortağı</div>
              </div>
            );
          })}
        </div>

        <div className="intro-text-in flex flex-col items-center gap-2" style={{ animationDelay: `${0.35 + myKeys.length * 0.25 + 0.25}s` }}>
          <div className="text-xs text-white/50">Devam etmek için ekrana dokunun</div>
          <div className="h-1 w-40 bg-white/10 rounded-full overflow-hidden">
            <div className="h-full bg-white/80 intro-progress" />
          </div>
        </div>
      </div>
    </div>
  );
}
